import * as tslib_1 from "tslib";
import * as i0 from "@angular/core";
import * as i1 from "../uuid.service";
import * as i2 from "../storage.service";
import * as i3 from "../hash.service";
import * as i4 from "./gpuFingerprint.service";
var ThumbmarkJS = require('@thumbmarkjs/thumbmarkjs');
var FingerprintService = /** @class */ (function () {
    function FingerprintService(uuidService, storageService, hashService, gpuFingerprintService) {
        this.uuidService = uuidService;
        this.storageService = storageService;
        this.hashService = hashService;
        this.gpuFingerprintService = gpuFingerprintService;
        this.DB_KEY = 'sn_fingerprint_device_uuid';
    }
    FingerprintService.prototype.getFullIdentity = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var deviceUuid, error_1, fpData, comps, audioHash, mathHash, webglHash, canvasHash, screenHash, timezone, _a, _b, _c, error_2;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.storageService.read(this.DB_KEY)];
                    case 1:
                        deviceUuid = _d.sent();
                        if (!!deviceUuid) return [3 /*break*/, 5];
                        _d.label = 2;
                    case 2:
                        _d.trys.push([2, 4, , 5]);
                        deviceUuid = this.uuidService.generateUUID();
                        return [4 /*yield*/, this.storageService.save(this.DB_KEY, deviceUuid)];
                    case 3:
                        _d.sent();
                        localStorage.setItem(this.DB_KEY, deviceUuid);
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _d.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        _d.trys.push([5, 8, , 9]);
                        return [4 /*yield*/, ThumbmarkJS.getThumbmark()];
                    case 6:
                        fpData = _d.sent();
                        comps = fpData && fpData.components ? fpData.components : {};
                        audioHash = comps.audio ? this.hashService.getParametersHash(comps.audio) : null;
                        mathHash = comps.math ? this.hashService.getParametersHash(comps.math) : null;
                        webglHash = comps.webgl ? this.hashService.getParametersHash(comps.webgl) : null;
                        canvasHash = comps.canvas ? this.hashService.getParametersHash(comps.canvas) : null;
                        screenHash = comps.screen ? this.hashService.getParametersHash(comps.screen) : null;
                        timezone = (comps.locales && comps.locales.timezone) ? comps.locales.timezone : null;
                        _a = {
                            device_uuid: deviceUuid,
                            hash: fpData ? this.hashService.getParametersHash(fpData.thumbmark) : null,
                            math: mathHash,
                            math2: this.hashService.getParametersHash(this.getHardwareEnvironment()),
                            webgl: webglHash
                        };
                        _c = (_b = this.hashService).getParametersHash;
                        return [4 /*yield*/, this.gpuFingerprintService.identity()];
                    case 7: return [2 /*return*/, (_a.gpu_math = _c.apply(_b, [_d.sent()]),
                            _a.canvas = canvasHash,
                            _a.audio = audioHash,
                            _a.screen = screenHash,
                            _a.timezone = timezone,
                            _a.local = this.hashService.getParametersHash(this.getLocaleSignals()),
                            _a.isStandalone = window.matchMedia('(display-mode: standalone)').matches,
                            _a)];
                    case 8:
                        error_2 = _d.sent();
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/, {
                            device_uuid: deviceUuid
                        }];
                }
            });
        });
    };
    FingerprintService.prototype.getMathFingerprint = function () {
        var results = {
            machineEps: undefined,
            largeFloat32: undefined,
            p32: undefined,
            poly1: undefined,
            poly2: undefined,
            poly3: undefined,
            poly4: undefined,
            bitShift1: undefined,
            bitShift2: undefined,
            bitShift3: undefined,
            bigSin: undefined,
            bigCos: undefined,
            tanAtan: undefined
        };
        var eps = 1.0;
        while ((1.0 + (eps / 2.0)) !== 1.0) {
            eps /= 2.0;
        }
        results.machineEps = eps;
        results.largeFloat32 = new Float32Array([123456.7890123456789])[0];
        results.p32 = Math.fround(Math.PI);
        results.poly1 = Math.pow(Math.E, Math.LN2);
        results.poly2 = Math.sinh(1) + Math.cosh(1);
        results.poly3 = Math.expm1(1) - (Math.E - 1);
        results.poly4 = Math.hypot(1e300, 1e300);
        results.bitShift1 = (0xffffffff >> 1);
        results.bitShift2 = (-1 >>> 1);
        results.bitShift3 = Math.clz32(1.5);
        results.bigSin = Math.sin(1e16);
        results.bigCos = Math.cos(1e16);
        results.tanAtan = Math.tan(Math.atan(1e15));
        var rawString = JSON.stringify(results);
        var hash = 0x811c9dc5;
        for (var i = 0; i < rawString.length; i++) {
            hash ^= rawString.charCodeAt(i);
            hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
        }
        return (hash >>> 0).toString(16);
    };
    ;
    FingerprintService.prototype.getHardwareEnvironment = function () {
        return {
            math: this.getMathFingerprint(),
            cores: navigator.hardwareConcurrency || 0,
            isTouch: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
            hasOrientation: typeof window.orientation !== 'undefined' || 'orientation' in screen
        };
    };
    ;
    FingerprintService.prototype.getLocaleSignals = function () {
        return {
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            offset: new Date().getTimezoneOffset(),
            languages: navigator.languages || [navigator.language],
            localeString: new Date(1700000000000).toLocaleString(),
            calendar: Intl.DateTimeFormat().resolvedOptions().calendar,
        };
    };
    ;
    FingerprintService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FingerprintService_Factory() { return new FingerprintService(i0.ɵɵinject(i1.UuidService), i0.ɵɵinject(i2.StorageService), i0.ɵɵinject(i3.HashService), i0.ɵɵinject(i4.GpuFingerprintService)); }, token: FingerprintService, providedIn: "root" });
    return FingerprintService;
}());
export { FingerprintService };
